var map = {
	"./death_knight.gif": 9558,
	"./druid.gif": 9420,
	"./hunter.gif": 7386,
	"./mage.gif": 7258,
	"./paladin.gif": 6921,
	"./priest.gif": 7337,
	"./rogue.gif": 4574,
	"./shaman.gif": 7462,
	"./warlock.gif": 391,
	"./warrior.gif": 5646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8383;